import { FolderOpen, Bot, BookOpen, Wrench } from "lucide-react";
import { useFavorites } from "@/hooks/useFavorites";
import { useNavigation } from "@/contexts/NavigationContext";

export const SidebarSectionFavorites = () => {
  const { navigateToProject, navigateToPersonal, navigateToGlobal, navigateToTab, setActiveAgentId, setActiveConversationId } = useNavigation();
  const { data: favorites } = useFavorites();

  if (!favorites || favorites.length === 0) return null;

  const handleSelectAgent = (fav: { target_id: string; target_scope_type?: string; target_project_id?: string | null }) => {
    if (fav.target_project_id) {
      navigateToProject(fav.target_project_id);
    } else if (fav.target_scope_type === 'personal') {
      navigateToPersonal();
    } else {
      navigateToGlobal();
    }
    setActiveAgentId(fav.target_id);
    setActiveConversationId(null);
    navigateToTab("chat");
  };

  return (
    <div>
      <h3 className="text-xs font-medium text-tertiary uppercase mb-2 px-3 flex items-center gap-1.5">
        Favoritos
      </h3>
      <div className="space-y-0.5">
        {favorites.map((fav) => {
          const favIcon =
            fav.target_type === "project" ? <FolderOpen className="w-3.5 h-3.5 shrink-0" /> :
            fav.target_type === "agent" ? <Bot className="w-3.5 h-3.5 shrink-0" /> :
            fav.target_type === "prompt" ? <BookOpen className="w-3.5 h-3.5 shrink-0" /> :
            <Wrench className="w-3.5 h-3.5 shrink-0" />;

          return (
            <button
              key={fav.id}
              onClick={() => {
                if (fav.target_type === "project") navigateToProject(fav.target_id);
                else if (fav.target_type === "agent") handleSelectAgent(fav);
              }}
              className="w-full flex items-center gap-2 px-3 py-1.5 text-xs text-secondary hover:bg-hover rounded-md transition-colors"
            >
              <span className="flex items-center gap-1.5 truncate">
                {favIcon} {fav.target_name}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
